export default __webpack_public_path__ + "static/latitude-scam-alert-6-1c0361a5c2279a179e6899b3eb20eb06.webp";